<!-- 小-阶梯 -->
<template>
  <div
    class="cardContent"
    :style="{
      backgroundImage: `url(${backgroundImage})`,
    }"
  >
    <div class="cardTop">
      <span class="title">{{ previewData.title || "这是小部件标题" }}</span>
      <span class="time"
        >距结束 <span class="day">xx</span>天 <span class="day">hh</span>:
        <span class="day">mm</span>: <span class="day">ss</span></span
      >
    </div>
    <div class="cardTab">
      <div
        v-for="(tab, index) in tabList"
        :key="index"
        class="tab_item"
        :class="{ active: index === activeTabIndex }"
      >
        <span class="tab_title">{{ tab.title }}</span>
      </div>
    </div>
    <div class="cardcenter">
      <div class="center-left">
        <div
          :class="{
            awardIconBox: true,
            chon: previewData.activityType == 36,
          }"
        >
          <img
            :src="previewData.logo || getLogo(previewData.prizeType)"
            style="width: 100%; height: 100%"
          />
          <span>{{ previewData.prizeName || "奖品名称" }}</span>
        </div>
        <span class="awardIndex"> 1/{{ previewData.imgCount }} </span>
      </div>
      <div class="center-right">
        <div class="activity-theme">
          {{ previewData.topic || "活动主题" }}
        </div>
        <div class="prize-count">剩余xxx份</div>
        <div v-if="previewData.activityType != 36" class="condition-text">
          {{ getConditionText() }}
        </div>
        <div v-if="previewData.activityType == 36" class="condition-text">
          仅统计时间内符合条件的金额的订单
        </div>
        <div v-if="previewData.activityType == 36" class="signup-button2">
          <span :style="{
            background: cusTemplateJSON.btnColor1 ? `linear-gradient( 33deg, ${cusTemplateJSON.btnColor1} 0%, ${cusTemplateJSON.btnColor2} 100%)` : ''
            }"
          >
            立即报名
          </span>
        </div>
      </div>
    </div>
    <div v-if="previewData.activityType != 36" class="cardbottom">
      <!-- 进度条 -->
      <div class="progress-container">
        <div class="progress-track">
          <div class="progress-fill"></div>
          <!-- 起始点：已买0元 -->
          <div class="progress-point start-point">
            <span class="point-label">已买0{{ getStatisticUnit }}</span>
          </div>
          <!-- 根据tabList显示的进度点 -->
          <div
            v-for="(tab, index) in tabList"
            :key="index"
            class="progress-point"
            :style="{
              left:
                index === tabList.length - 1
                  ? '100%'
                  : `${((index + 1) / tabList.length) * 80}%`,
            }"
          >
            <div class="point-dot"></div>
            <span class="point-label">{{ tab.title }}</span>
          </div>
        </div>
      </div>
      <div class="signup-button">
        <span :style="{
          background: cusTemplateJSON.btnColor1 ? `linear-gradient( 33deg, ${cusTemplateJSON.btnColor1} 0%, ${cusTemplateJSON.btnColor2} 100%)` : ''
          }"
        >
          立即报名
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityCard",
  props: {
    previewData: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    tabData: {
      type: Array,
      default: () => [],
    },
    unitName: {
      type: String,
      default: "",
    },
    cusTemplateJSON: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeTabIndex: 0,
    };
  },
  computed: {
    getStatisticUnit() {
      const statisticType = this.previewData.statisticType;
      switch (statisticType) {
        case 0:
          return "元";
        case 1:
          return "件";
        case 3:
          return "笔";
        case 4: // 自定义计量单位
          return this.unitName;
        default:
          return "元"; // 默认显示元
      }
    },
    // tab列表
    tabList() {
      if (this.tabData && this.tabData.length > 0) {
        return this.tabData;
      }
      if (this.previewData.activityType == 36) {
        if (this.previewData.rankType == 0) {
          // 当 rankType 为 0 时，根据 stepList 数量生成 top1, top2, top3 等格式
          if (
            this.previewData.stepList &&
            this.previewData.stepList.length > 0
          ) {
            return this.previewData.stepList.map((step, index) => {
              const topNumber = index + 1;
              return {
                title: `top${topNumber}`,
                value: step.orderPaymentLimit,
                taskIndex: index + 1,
                stepData: step,
                rank: topNumber,
              };
            });
          }
        }

        // 针对活动类型36的特殊处理 - 生成topX~topY格式
        if (this.previewData.stepList && this.previewData.stepList.length > 0) {
          let currentStart = 1;
          return this.previewData.stepList.map((step, index) => {
            const currentEnd = currentStart + step.orderPaymentLimit - 1;
            const title = `top${currentStart}~top${currentEnd}`;
            const result = {
              title,
              value: step.orderPaymentLimit,
              taskIndex: index + 1,
              stepData: step,
              startRank: currentStart,
              endRank: currentEnd,
            };
            currentStart = currentEnd + 1;
            return result;
          });
        }
      }
      // 根据stepList生成tab数据
      if (this.previewData.stepList && this.previewData.stepList.length > 0) {
        return this.previewData.stepList.map((step, index) => {
          const statisticType = this.previewData.statisticType;
          let title = "";
          let value = 0;

          switch (statisticType) {
            case 0: // 满额
              title = `满${step.orderPaymentLimit}${this.getStatisticUnit}`;
              value = step.orderPaymentLimit;
              break;
            case 1: // 满件
              title = `满${step.itemLimitCount}${this.getStatisticUnit}`;
              value = step.itemLimitCount;
              break;
            case 2: // 满额且满件
              title = `满${step.orderPaymentLimit}${this.getStatisticUnit}且${step.itemLimitCount}件`;
              value = step.itemLimitCount;
              break;
            case 3: // 满笔
              title = `满${step.orderLimitCount}${this.getStatisticUnit}`;
              value = step.orderLimitCount;
              break;
            case 4: // 自定义计量单位
              title = `满${step.measureUnitLimitCount}${this.getStatisticUnit}`;
              value = step.measureUnitLimitCount;
              break;
            default:
              title = `满${step.orderPaymentLimit}${this.getStatisticUnit}`;
              value = step.orderPaymentLimit;
          }
          return {
            title,
            value,
            taskIndex: step.taskIndex,
            stepData: step,
          };
        });
      }
    },
  },
  methods: {
    getConditionText() {
      // 当activityType为46时，根据statisticType判断
      if (this.previewData.activityType === 46) {
        const statisticType = this.previewData.statisticType;
        const orderCountType = this.previewData.orderCountType;
        const orderPaymentLimit = this.previewData.orderPaymentLimit;
        const itemLimitCount = this.previewData.itemLimitCount;
        const orderLimitCount = this.previewData.orderLimitCount;
        const measureUnitLimitCount = this.previewData.measureUnitLimitCount;

        const prefix = orderCountType == 1 ? "累计" : "单笔";

        switch (statisticType) {
          case 0: // 满额
            return `${prefix}满${orderPaymentLimit}元(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 1: // 满件
            return `${prefix}满${itemLimitCount}件(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 2: // 满额满件
            return `${prefix}满${orderPaymentLimit}元且商品满${itemLimitCount}件(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 3: // 满笔
            return `${prefix}满${orderLimitCount}笔(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 4: // 自定义计量单位
            return ` ${prefix}满${measureUnitLimitCount}${this.getStatisticUnit}`;
          default:
            return `${prefix}满${orderPaymentLimit}元且商品满${itemLimitCount}件(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
        }
      } else {
        // 其他活动类型都是满额满件
        const orderCountType = this.previewData.orderCountType;
        const orderPaymentLimit = this.previewData.orderPaymentLimit;
        const itemLimitCount = this.previewData.itemLimitCount;
        const prefix = orderCountType == 1 ? "累计" : "单笔";
        return `${prefix}满${orderPaymentLimit}元且商品满${itemLimitCount}件`;
      }
    },
    // 获取图片
    getLogo(prizeType) {
      let logo = "";
      if (prizeType == 1) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_coupon.png";
      } else if (prizeType == 2) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_jd.png";
      } else if (prizeType == 4) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_jf.png";
      } else if (prizeType == 5) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_ecard.png";
      } else if (prizeType == 6) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_iqiyi.png";
      } else if (prizeType == 7) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_plus.png";
      } else {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_hb.png";
      }
      return logo;
    },
  },
  mounted() {
    console.log("--- ~ this.previewData2:---", this.previewData);
  },
};
</script>

<style lang="scss" scoped>
.cardContent {
  position: absolute;
  top: 170px;
  left: 5px;
  width: 100%;
  height: 112px;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;

  .cardTop {
    display: flex;
    justify-content: space-between;
    padding: 4px 14px 0px 4px;
    font-size: 8px;

    .title {
      color: #fff;
      width: 65px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .time {
      .day {
        color: #ce2d2f;
        padding: 0px 4px;
        background-color: rgba(255, 255, 255, 0.65);
      }
    }
  }

  .cardTab {
    display: flex;
    margin-right: 12px;
    margin-top: 8px;
    overflow: auto;

    // 隐藏滚动条
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
      background-color: #f5f8fa;
      border-radius: 10px;
      padding: 5px 0;
    }

    &:hover::-webkit-scrollbar {
      width: 0px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #d6d8dd;
      overflow: hidden;
    }

    .tab_item {
      height: 12px;
      // max-width: 80px;
      flex: 0 0 auto;
      // background-color: #f8f8f8;
      border-radius: 6px 6px 0 0;
      padding: 0px 15px;
      text-align: center;
      line-height: 9px;
      cursor: pointer;
      transition: all 0.3s ease;
      border-bottom: none;

      .tab_title {
        font-size: 8px;
        color: #666;
        line-height: 9px;
        font-weight: 500;
      }

      &.active {
        background-color: rgba(255, 255, 255, 0.7);
        box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);

        .tab_title {
          color: #333;
          font-weight: 600;
        }
      }
    }
  }

  .cardcenter {
    display: flex;
    margin: 0 13px 0 1px;
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 0px 0px 8px 8px;
    .center-left {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;

      .awardIconBox {
        font-size: 8px;
        width: 55px;
        // background-color: #fff;
        padding: 5px 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        position: relative;

        &.chon {
          width: 65px;
          span {
            width: 45px;
            bottom: 5px;
          }
        }

        img {
          width: 100%;
          height: 60px;
          border-radius: 6px;
        }
        span {
          width: 35px;
          height: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          position: absolute;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          color: #fff;
          font-size: 6px;
          text-align: center;
          line-height: 12px;
          border-radius: 0 0 6px 6px;
        }
      }

      .awardIndex {
        font-size: 8px;
      }
    }

    .center-right {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 0 8px 5px 8px;

      .activity-theme {
        color: #333;
        font-size: 12px;
        font-weight: bold;
        text-align: start;
        margin-top: 10px;
      }

      .prize-count {
        width: 40px;
        background-color: rgba(0, 0, 0, 0.2);
        color: #fff;
        font-size: 6px;
        padding: 2px 4px;
        text-align: center;
        border-radius: 2px;
      }

      .condition-text {
        color: #999;
        font-size: 8px;
        text-align: center;
        line-height: 1.2;
      }

      .progress-line {
        display: flex;
        align-items: center;
        margin: 1px 0;

        .progress-bar {
          flex: 1;
          height: 1px;
          background-color: rgba(255, 255, 255, 0.5);
          position: relative;

          .progress-fill {
            width: 50%; // 可以根据实际进度调整
            height: 100%;
            background-color: #000;
            border-radius: 1px;
          }
        }

        .progress-dot {
          width: 4px;
          height: 4px;
          background-color: #000;
          border-radius: 50%;
          margin-left: -8px;
          position: relative;
          z-index: 1;
        }
      }

      .amount-display {
        display: flex;
        justify-content: space-between;
        font-size: 8px;

        .bought-amount {
          color: #333;
        }

        .target-amount {
          color: #333;
        }
      }
    }
  }
}

.cardbottom {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: -7px;
  padding: 0 12px;
}

.progress-container {
  flex: 1;

  .progress-track {
    position: relative;
    height: 2px;
    background-color: #bec2c6;
    border-radius: 1px;
    margin: 12px 0;

    .progress-fill {
      position: absolute;
      top: 0;
      left: 0;
      width: 60%; /* 固定进度 */
      height: 100%;
      background-color: #000000;
      border-radius: 1px;
    }

    .progress-point {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);

      &.start-point {
        left: 0;
        transform: translate(-50%, -50%);

        .point-label {
          position: absolute;
          bottom: 8px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 6px;
          color: #333;
          white-space: nowrap;
        }
      }

      .point-dot {
        width: 4px;
        height: 4px;
        background-color: #000000;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        margin-bottom: -4px;
      }

      .point-label {
        position: absolute;
        top: 8px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 6px;
        color: #333;
        white-space: nowrap;
      }
    }
  }
}

.signup-button {
  display: flex;
  justify-content: end;
  margin-top: 12px;

  span {
    background-color: #000;
    color: #fff;
    width: 60px;
    font-size: 9px;
    text-align: center;
    padding: 3px 6px;
    border-radius: 10px;
    cursor: pointer;
  }
}
.signup-button2 {
  display: flex;
  justify-content: end;
  margin-right: -8px;
  align-items: center;

  span {
    background-color: #000;
    color: #fff;
    width: 60px;
    font-size: 8px;
    text-align: center;
    padding: 3px 6px;
    border-radius: 10px;
    cursor: pointer;
  }
}
</style>
